if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('[data-submit-label]') || this.submitButton.querySelector('span');
        this.fastAdd = this.dataset.fastAdd === 'true';

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.setPendingButtonText();
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        this.trackCartEvent('add_to_cart_submit', {
          variant_id: formData.get('id'),
          pack: window.__infCurrentPack || 'single'
        });
        const fastAdd = this.fastAdd && !this.closest('quick-add-modal');

        if (this.cart && !fastAdd) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.trackCartEvent('add_to_cart_error', {
                variant_id: formData.get('id'),
                pack: window.__infCurrentPack || 'single',
                message: response.message || response.description
              });
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (fastAdd) {
              this.trackCartEvent('add_to_cart_success', {
                variant_id: formData.get('id'),
                pack: window.__infCurrentPack || 'single',
                fast_add: 'true'
              });
              this.error = false;
              this.renderFastAddCart(response);
              this.publishCartUpdateInBackground(response);
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            this.trackCartEvent('add_to_cart_success', {
              variant_id: formData.get('id'),
              pack: window.__infCurrentPack || 'single',
              cart_item_count: response.item_count,
              cart_total_price: response.total_price
            });
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            this.trackCartEvent('add_to_cart_exception', {
              variant_id: formData.get('id'),
              pack: window.__infCurrentPack || 'single',
              message: e && e.message
            });
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.restorePendingButtonText();

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      setPendingButtonText() {
        if (!this.submitButtonText) return;
        this.pendingSubmitButtonText = this.submitButtonText.textContent;
        this.submitButtonText.classList.remove('is-restoring');
        this.submitButtonText.classList.add('is-changing');
        this.submitButtonText.textContent = window.variantStrings && window.variantStrings.adding
          ? window.variantStrings.adding
          : 'Adding...';
        window.setTimeout(() => {
          if (this.submitButtonText) this.submitButtonText.classList.remove('is-changing');
        }, 180);
      }

      restorePendingButtonText() {
        if (!this.submitButtonText || !this.pendingSubmitButtonText) return;
        this.submitButtonText.classList.add('is-restoring');
        this.submitButtonText.textContent = this.pendingSubmitButtonText;
        this.pendingSubmitButtonText = '';
        window.setTimeout(() => {
          if (this.submitButtonText) this.submitButtonText.classList.remove('is-restoring');
        }, 180);
      }

      renderFastAddCart(response) {
        if (!this.cart || !response || !response.key || typeof this.cart.getSectionsToRender !== 'function') return;

        const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
        if (!sectionIds.length) return;

        const params = new URLSearchParams({
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        });

        this.cart.setActiveElement(document.activeElement);

        fetch(`${routes.cart_url}?${params.toString()}`)
          .then((sectionResponse) => sectionResponse.json())
          .then((sections) => {
            if (!sections || typeof sections !== 'object') throw new Error('Missing cart sections');
            this.cart.renderContents({
              ...response,
              sections,
            });
          })
          .catch((error) => {
            console.warn('Fast add cart popup failed:', error);
          });
      }

      publishCartUpdateInBackground(response) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form-fast-add',
            productVariantId: response && response.variant_id,
            cartData: response,
          }).catch((error) => {
            console.warn('Background cart refresh failed:', error);
          });
        }
      }

      trackCartEvent(name, payload = {}) {
        if (!window.InfiSharkAnalytics || typeof window.InfiSharkAnalytics.track !== 'function') return;
        window.InfiSharkAnalytics.track(name, {
          source: 'product-form',
          section_id: this.dataset.sectionId,
          ...payload,
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
